import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import "./Sidebarpo.css";

import dashboord from '../assets/images/sidebaricon.png';
import dashboord1 from '../assets/images/sidebaricon1.png';
import dashboord2 from '../assets/images/sidebaricon2.png';
import dashboord3 from '../assets/images/sidebaricon3.png';
import dashboord4 from '../assets/images/sidebaricon4.png';
import dashboord5 from '../assets/images/sidebaricon5.png';

import hover from '../assets/images/hovericon.png';
import hover1 from '../assets/images/hovericon1.png';
import hover2 from '../assets/images/hovericon2.png';
import hover3 from '../assets/images/hovericon3.png';
import hover4 from '../assets/images/hovericon4.png';
import hover5 from '../assets/images/hovericon5.png';

import logo from '../assets/images/WhatsApp Image 2025-08-14 at 7.05.00 PM.jpeg';

const SidebarRFQ = () => {
  const [hovered, setHovered] = useState(null);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => setIsMobileOpen(!isMobileOpen);
  const closeSidebar = () => setIsMobileOpen(false);

  const menuItems = [
    { path: "/dashboard", name: "Dashboard", icon: dashboord, hoverIcon: hover },
    { path: "/createrfq", name: "Create RFQ", icon: dashboord1, hoverIcon: hover1 },
    { path: "/listrfq", name: "RFQ List", icon: dashboord4, hoverIcon: hover4 },
    { path: "/clientadd", name: "Client", icon: dashboord3, hoverIcon: hover3 },
    { path: "/supplier", name: "Supplier Directory", icon: dashboord2, hoverIcon: hover2 },
    { path: "/supplierrfq", name: "RFQs by Client", icon: dashboord5, hoverIcon: hover5 },
  ];

  return (
    <>
      <button className="sidebar-toggle d-md-none" onClick={toggleSidebar}>☰</button>
      <div className={`sidebar-wrapper ${isMobileOpen ? "open" : ""}`}>
        <div className="sidebar p-4">
          <button className="close-btn d-md-none" onClick={closeSidebar}>✕</button>
          {/* <h6 className="sidebarheding mt-4">BI <span>Manager</span></h6> */}
          <h6 className="sidebarheding mt-4">
            <img src={logo}
            style={{width:'140px'}}
            />
          </h6>
          <ul className="list-unstyled mt-5">
            {menuItems.map((item, index) => (
              <li
                key={index}
                className={`nav-item mb-2 ${
                  location.pathname === item.path ? "active" : ""
                }`}
                onMouseEnter={() => setHovered(index)}
                onMouseLeave={() => setHovered(null)}
              >
                <Link className="nav-link d-flex align-items-center" to={item.path}>
                  <img
                    src={
                      hovered === index
                        ? item.hoverIcon
                        : location.pathname === item.path
                        ? item.hoverIcon
                        : item.icon
                    }
                    alt={item.name}
                    className="me-2"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <span className="ml-3">{item.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SidebarRFQ;
